import { NUMBER_1, NUMBER_2, NUMBER_3, NUMBER_4 } from '~shared/constants/magic-numbers.constants';

export enum UserTypeEnum {
  CONSUMER = NUMBER_1,
  METRO_CARD = NUMBER_2,
  DIGITAL = NUMBER_3,
  NEW_BUSINESS = NUMBER_4
}
